import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

// Uso: await logAudit({ module: 'Usuarios', action: 'user.updated', details: { ... }, target: { id, type } }, currentUser)
export async function logAudit(event = {}, currentUser = null) {
  try {
    const uid = currentUser?.uid || currentUser?.id || null;
    const emailRaw = currentUser?.email || null;
    const email = emailRaw ? String(emailRaw).toLowerCase() : null;
    const display = currentUser?.displayName || currentUser?.name || currentUser?.username || emailRaw || uid || '—';

    const payload = {
      createdAt: serverTimestamp(),
      module: event.module || 'General',
      action: event.action || 'event',
      severity: event.severity || 'info', // info | warning | critical
      details: event.details ?? null,
      target: event.target ?? null,
      // Campos normalizados para filtros
      userId: uid,
      userEmail: email,
      userDisplay: display,
      // Objeto original para compatibilidad hacia atrás
      user: currentUser
        ? {
            uid,
            email: emailRaw || null,
            name: currentUser.displayName || currentUser.name || currentUser.username || null,
          }
        : null,
    };
    await addDoc(collection(db, 'auditLogs'), payload);
  } catch (e) {
    // No romper la UX por fallos de auditoría, pero deja traza para depurar
    // Tip: si ves 'permission-denied' o 'failed-precondition', revisa reglas/índices para /auditLogs
    try { console.warn('auditLogs write failed:', e?.code || e?.message || e); } catch {}
  }
}

export default { logAudit };

